<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل بيانات العميل' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>تسوية الحوافظ</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم تسوية جميع الحوافظ
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
                <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                </ul>
              </div>
              <div class='alert alert-success alert-dismissable' v-if='successShow'>
                'تم الحفظ بنجاح'
              </div>
              <div class="row">
                <div class='col-lg-3 col-md-3 col-sm-6'  style="padding: 3px 12px 5px 0px">
                  <label>الفرع</label>
                  <select @change="UpdateCollectors()" style="padding: 0px" class="form-control"  v-model="branch_id" >
                    <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 3px 5px 5px 0px">
                  <tbDate :today='today' :mytitle='folderDateFrom' v-model= 'folder_date_from' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 3px 5px 5px 0px">
                  <tbDate :today='today' :mytitle='folderDateTo' v-model= 'folder_date_To' ></tbDate>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' s style="padding: 3px 5px 5px 12px">
                  <label>المحصل:</label>
                <div class="form-group input-group">
                  <span class="input-group-btn">
                    <vue-element-loading size='32' :active='isgetTec' spinner='spinner' color='#A4A4A4'/>
                      <button
                        @click="getTec()" class="btn btn-default" type="button"><i class="fa fa-search"></i>
                      </button>
                  </span>
                  <select class="form-control" style="padding: 0px" v-model="collector_id">
                    <option v-for="collector in collectors" v-bind:key="collector.id" v-bind:value="collector.id">
                      {{ collector.name }}
                    </option>
                  </select>
                  </div>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6'  style="padding: 0px 12px 5px 0px">
                    <label>الترتيب</label>
                    <select class="form-control" style="padding: 0px" v-model="sort">
                      <option value='cash_receipts.id'>رقم الايصال</option>
                      <option value='customers.region_id'>المنطقة</option>
                      <option value='customers.rec_id'>كود العميل</option>
                      <option value='customers.name'>الاسم</option>
                    </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 0px 5px 5px 0px">
                    <label>العرض</label>
                    <select class="form-control" style="padding: 0px"  v-model="displayTypeID" >
                      <option v-for="item in displayType" v-bind:key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-3 col-md-3 col-sm-6' style="padding: 4px 5px 5px 0px">
                  <span>&nbsp;</span>
                  <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                    عرض
                  </button>
                </div>
              </div>
              <div class='form-group col-lg-2 col-sm-2' style='padding: 3px 0px 5px 5px;'>
                <span>رقم الايصال:</span>
                <input  @keypress="KeyDownID($event)" v-model='id' class='form-control' name='name' type='text' ref="id">
              </div>
                <div class='col-lg-2 col-md-2 col-sm-6' style='padding: 3px 3px 5px 5px;' >
                    <span>الحالة</span>
                    <select class="form-control" style="padding: 0px" @keypress="KeyDownStatus($event)" v-model="status" ref="status">
                      <option value='1'>1-مرتجع</option>
                      <option value='5'>2-مفقود</option>
                      <option value='3'>3-ملغى</option>
                      <option value='6'>4-مشكلة</option>
                    </select>
                </div>
                <div v-show ='parseInt(status) !== 3' class='col-lg-2 col-sm-2' style='padding: 3px 0px 5px 5px;'>
                  <span>التأجيل:</span>
                  <select class="form-control" @keypress="KeyDownDelay($event)" style="padding: 0px" v-model="delay" ref="delay">
                    <option v-for="item in 30" :value="item -1 " v-bind:key="item" >
                      {{ item -1 }}
                    </option>
                  </select>
                </div>
                <div class='form-group col-lg-4 col-sm-4' style='padding: 3px 0px 5px 5px;'>
                    <span>ملاحظات:</span>
                    <input@keypress="getRec($event)"  v-model='notes' class='form-control' name='notes' type='text' ref="notes">
                </div>
                <div class='col-lg-2 col-md-2 col-sm-6'  style='padding: 3px 0px 5px 0px;' >
                  <span>&nbsp;</span>
                  <button @click="SetFolderReceipt()" type='button' class='btn btn-outline btn-primary btn-md btn-block '>
                  حفظ
                  </button>
                </div>
              <br>
              <div>
                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                  <thead>
                    <tr>
                      <th style='text-align: center'>م</th>
                      <th style='text-align: center'>الايصال</th>
                      <th style='text-align: center'>الاسم</th>
                      <th style='text-align: center'>الحالة</th>
                      <th style='text-align: center'>ملاحظات</th>
                      <th style='text-align: center'>الفنى</th>
                      <th style='text-align: center'>حافظة الاصدار</th>
                      <th style='text-align: center'>الاجراء</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :class="{fcolorBlue :record.status == 1,deleted :record.status == 3,fcolorgreen :record.status == 4,fcolor :record.status == 5 || record.status == 6}" class='odd gradeX' v-for='(record,index) in savedRec' :key='record.id'>
                      <td align='center'> <i v-if='record.receipt_handles.length > 0'  data-toggle='modal' data-target='#OldHandelRecepts'  @click='showOldHandels(record)' class="fa fa-plus" ></i> {{index +1 }}</td>
                      <td align='center'>{{record.id}}</td>
                      <td align='center'>{{record.name}}</td>
                      <td align='center'>{{record.type}}</td>
                      <td align='center'>{{record.notes}}</td>
                      <td align='center'>{{record.tec_name}}</td>
                      <td align='center'>{{record.folder_date}}</td>
                      <td align='center'>
                        <button  @click='Unclassification(record.id)' type='button' class='btn btn-outline btn-info btn-xs' >تراجع الحالة</button>
                      </td>
                    </tr>
                    <tr :class="{fcolorBlue :record.status == 1,deleted :record.status == 3,fcolorgreen :record.status == 4,fcolor :record.status == 5}" class='odd gradeX' v-for='(record,index) in unSavedRec' :key='record.id'>
                      <td align='center'> <i v-if='record.receipt_handles.length > 0'  data-toggle='modal' data-target='#OldHandelRecepts'  @click='showOldHandels(record)' class="fa fa-plus"></i> {{index + savedRec.length +1 }}</td>
                      <td align='center'>{{record.id}}</td>
                      <td align='center'>{{record.name}}</td>
                      <td align='center'>{{record.type}}</td>
                      <td align='center'>{{record.notes}}</td>
                      <td align='center'>{{record.tec_name}}</td>
                      <td align='center'>{{record.folder_date}}</td>
                      <td align='center'>
                        <button v-show="record.status !== record.old_status" @click='Unclassification(record.id)' type='button' class='btn btn-outline btn-info btn-xs' >تراجع الحالة</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- Modal -->
    <div class='modal fade' id='OldHandelRecepts' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
        <div class='modal-dialog  modal-lg'>
            <div class='modal-content'>
                <div class='modal-header'>
                    <button type='button' class='close'  data-toggle='modal' data-target='#OldHandelRecepts' aria-hidden='true'>&times;</button>
                    <h4 class='modal-title' id='myModalLabel'>حالات سابقة</h4>
                </div>
                <form role='form'>
                <div class='modal-body'>
                  <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                    <thead>
                      <tr>
                        <th style='text-align: center'>م</th>
                        <th style='text-align: center'>الحافظة</th>
                        <th style='text-align: center'>الفنى</th>
                        <th style='text-align: center'>التأجيل</th>
                        <th style='text-align: center'>ملاحظات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class='odd gradeX' v-for='(record,index) in handeRecords' :key='index'>
                        <td align='center'>{{index +1 }}</td>
                        <td align='center'>{{record.folder_date}}</td>
                        <td align='center'>{{record.name}}</td>
                        <td align='center'>{{record.delay}}</td>
                        <td align='center'>{{record.notes}}</td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                  <div class='modal-footer'>
                      <button type='button' class='btn btn-default' data-toggle='modal' data-target='#OldHandelRecepts'>خروج</button>
                  </div>
                </form>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- /.container-fluid -->
  </div>
</template>
<style>
.fcolor {
   color: #FF0000;
}
.fcolorgreen {
   color: #0BB21A;
}
.fcolorBlue {
   color: #0000FF;
}
.deleted {
  text-decoration: line-through;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'Settlementcollectorsaccounts',
  data () {
    return {
      isgetTec: false,
      notes: '',
      delay: 0,
      status: 1,
      receiptsBranch_id: null,
      sort: 'cash_receipts.id',
      today: true,
      folderDateFrom: 'من حافظة',
      folderDateTo: 'إلى حافظة',
      folder_date_from: '',
      folder_date_To: '',
      emptyRec: {id: 0, name: 'جميع الحوافظ'},
      displayType: [{id: -1, name: 'الكل'}, {id: 0, name: 'مصدر'}, {id: 1, name: 'مرتجع'}, {id: 2, name: 'موزع'}, {id: 3, name: 'ملغى'}, {id: 5, name: 'مفقود'}, {id: 6, name: 'مشكلة'}, {id: -2, name: 'إيصالات معلقة'}],
      displayTypeID: -1,
      validationErrors: '',
      records: '',
      errorShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      CollectorsSuccess: '',
      CollectorsvalidationErrors: '',
      branches: {},
      branch_id: 0,
      successShow: false,
      modelCollectors: {},
      collectors: {},
      CollectorRecords: [],
      handeRecords: '',
      collector_id: 0,
      id: ''
    }
  },
  computed: {
    savedRec () {
      if (this.records) {
        return this.records.filter(item => item.status !== item.old_status)
      }
    },
    unSavedRec () {
      if (this.records) {
        return this.records.filter(item => item.status === item.old_status)
      }
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branch_id = JSON.parse(localStorage.getItem('BrancheID'))
    this.UpdateCollectors()
  },
  methods: {
    UpdateCollectors () {
      this.records = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch_id))
      if (i > -1) {
        this.collectors = this.branches[i].collectors
        this.collectors.unshift(this.emptyRec)
      }
      this.collector_id = 0
    },
    changeCollectors () {
      this.records = ''
    },
    // ===========================================================
    GetData () {
      this.records = ''
      this.successShow = false
      this.isLoadingData = true
      axios.post(this.$apiURL + 'get-folder-receipts-for-settlement', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        collector_id: this.collector_id,
        sort: this.sort,
        type: this.displayTypeID,
        from: this.folder_date_from,
        to: this.folder_date_To
      })
        .then(({ data }) => {
          if (data.length > 0) {
            this.records = data
          }
          this.isLoadingData = false
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ===========================================================
    KeyDownStatus (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 13) {
        if (parseInt(this.status) === 3) {
          this.$refs.notes.focus()
        } else {
          this.$refs.delay.focus()
        }
        evt.preventDefault()
      }
    },
    // ===========================================================
    KeyDownID (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 13) {
        evt.preventDefault()
        this.$refs.status.focus()
      }
    },
    // ===========================================================
    KeyDownDelay (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 13) {
        evt.preventDefault()
        this.$refs.notes.focus()
      }
    },
    // ===========================================================
    showOldHandels (rec) {
      this.handeRecords = rec.receipt_handles
    },
    // ===========================================================
    getRec (evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if (charCode === 13) {
        evt.preventDefault()
        let i = this.records.map(record => record.id).indexOf(parseInt(this.id))
        if (i > -1) {
          if (parseInt(this.records[i].status) !== 4) {
            var type = ''
            switch (parseInt(this.status)) {
              case 1:
                type = 'مرتجع'
                break
              case 3:
                type = 'ملغى'
                break
              case 5:
                type = 'مفقود'
                break
              case 6:
                type = 'مشكلة'
                break
              default:
                type = ''
            }
            this.records[i].type = type
            this.records[i].notes = this.notes
            this.records[i].status = parseInt(this.status)
            this.records[i].delay = parseInt(this.delay)
            this.id = ''
            this.notes = ''
            this.delay = 0
            this.status = 1
            this.$refs.id.focus()
          }
        }
      } else {
        return true
      }
    },
    // ========================================================
    getTec () {
      this.isgetTec = true
      axios.post(this.$apiURL + 'get-folder-tec-between', {
        token: localStorage.getItem('token'),
        branch_id: this.branch_id,
        from: this.folder_date_from,
        to: this.folder_date_To
      })
        .then(({ data }) => {
          this.collectors = data
          this.collectors.unshift(this.emptyRec)
          this.isgetTec = false
        })
        .catch(err => {
          if (err) {
            this.isgetTec = false
          }
        })
    },
    // ===========================================================
    Unclassification (id) {
      let i = this.records.map(record => record.id).indexOf(parseInt(id))
      if (i > -1) {
        this.records[i].status = this.records[i].old_status
        this.records[i].notes = this.records[i].old_notes
        this.records[i].delay = this.records[i].old_delay
        this.records[i].type = this.records[i].old_type
      }
    },
    // ===========================================================
    SetFolderReceipt () {
      // this.isLoadingData = true
      this.successShow = false
      axios.post(this.$apiURL + 'set-folder-receipt', {
        token: localStorage.getItem('token'),
        savedRec: this.savedRec,
        collector_id: this.collector_id,
        folder_date: this.folder_date
      })
        .then(({ data }) => {
          if (data.length > 0) {
            this.records = data
          }
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    }
    // ===========================================================
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Settlementcollectorsaccounts.vue